export default __webpack_public_path__ + "static/media/careplix-logo.784ea9f5.png";